import React from "react";
import { Button, Card, Col, Form, Modal, Row } from "react-bootstrap";

const AddEdit = ({ show, onHide, currentItems, formatDate }) => {
  return (
    <Modal
      show={show}
      onHide={() => {
        onHide();
      }}
      centered
    >
      <Modal.Header closeButton className="py-2">
        <Modal.Title className="fw-bold fs-5">View Details</Modal.Title>
      </Modal.Header>
      <Form className="common-modal" noValidate autoComplete="off">
        <Modal.Body className="p-4">
          <Row>
            <Col md={6} className="mb-3">
              <Form.Group>
                <Form.Label className="fw-bold">Name</Form.Label>
                <Card.Text>{`${currentItems?.firstName} ${currentItems?.lastName}`}</Card.Text>
              </Form.Group>
            </Col>
            <Col md={6} className="mb-3">
              <Form.Group>
                <Form.Label className="fw-bold"> Email</Form.Label>
                <Card.Text>{`${currentItems?.email}`}</Card.Text>
              </Form.Group>
            </Col>
            <Col md={6} className="mb-3">
              <Form.Group>
                <Form.Label className="fw-bold"> Mobile No</Form.Label>
                <Card.Text>{`${currentItems?.mobile}`}</Card.Text>
              </Form.Group>
            </Col>
            <Col md={6} className="mb-3">
              <Form.Group>
                <Form.Label className="fw-bold">Date</Form.Label>
                <Card.Text>{formatDate(currentItems?.createdAt)}</Card.Text>
              </Form.Group>
            </Col>
            <Col md={12} className="mb-3">
              <Form.Group>
                <Form.Label className="fw-bold">Message</Form.Label>
                <Card.Text>{currentItems?.message}</Card.Text>
              </Form.Group>
            </Col>
          </Row>
        </Modal.Body>
        <Modal.Footer className="justify-content-center">
          <Button
            variant="primary"
            type="submit"
            className="bg-orange border-0"
            onClick={() => onHide()}
          >
            Close
          </Button>
        </Modal.Footer>
      </Form>
    </Modal>
  );
};

export default AddEdit;
